module.exports = __webpack_public_path__ + "media/applications/assets/images/materials/classic-tee/17-6c41147c9c905d07556294ebaa3ceef6.jpg";